import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Container, NavItem } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { accessRoute } from '../../routes/Auth/customer';
import { accessRoute as StoreAccessRoute } from '../../routes/Auth/store';
import ImageElement from '../UIElements/ImageElement';

function StoreHeader() {
  // { routes }
  const headerData = [
    { path: StoreAccessRoute.ABOUT_US.path, name: 'About Us' },
    { path: StoreAccessRoute.HOW_IT_WORKS.path, name: 'How It Works' },
    { path: StoreAccessRoute.FAQ.path, name: 'Faq' },
    { path: StoreAccessRoute.CONTACT_US.path, name: 'Contact Us' },
  ];

  const [scroll, setScroll] = useState(0);

  const location = useLocation();
  const { pathname } = location;
  let path = pathname.replace('/', '');

  useEffect(() => {
    document.addEventListener('scroll', () => {
      const scrollCheck = window.scrollY > 50;
      if (scrollCheck !== scroll) {
        setScroll(scrollCheck);
      }
    });
  });

  useEffect(() => {
    if (['home'].includes(path)) {
      document.querySelector('body').style.paddingTop = `0px`;
    } else {
      setTimeout(() => {
        let navbar = document.querySelector('.header').clientHeight;
        document.querySelector('body').style.paddingTop = `${navbar}px`;
      }, 300);
    }
  });
  return (
    <header className={`header position-fixed w-100 ${scroll ? 'scroll' : ''}`}>
      <Container>
        <Navbar expand="lg" className="p-0">
          <Navbar.Brand href="/" className="p-0 me-0">
            <ImageElement source="logo.svg" alt="logo" />
          </Navbar.Brand>

          <>
            <Navbar.Collapse id="navbarScroll">
              <Nav as="ul" className="mx-auto">
                {headerData.length &&
                  headerData.map((item, key) => {
                    return (
                      <NavItem as="li" key={key}>
                        <Link to={item.path} className="p-0 nav-link">
                          {item.name}
                        </Link>
                      </NavItem>
                    );
                  })}
              </Nav>
            </Navbar.Collapse>
            <div className="d-flex actionBtn align-items-center">
              <Link
                to={accessRoute.CUSTOMER_SIGNUP.path}
                className="btn btn-primary"
              >
                Book Online
              </Link>
            </div>
            <Navbar.Toggle
              as="a"
              className="border-0 p-0"
              aria-controls="navbarScroll"
            >
              <span className="navbar-toggler-icon"></span>
              <span className="navbar-toggler-icon"></span>
              <span className="navbar-toggler-icon"></span>
            </Navbar.Toggle>
          </>
        </Navbar>
      </Container>
    </header>
  );
}

export default StoreHeader;
